import React, { useContext }  from 'react'
import GroutProduct from './GroutProduct'
import { AppContext } from '../../../App'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'

export default function GroutProductList() {
   const { groutProducts } = useContext(AppContext)
   const allGroutSubCategories = groutProducts.map(g => g.subCategory)
   const groutSubCategories = [...new Set(allGroutSubCategories)]
   const iconAngleDown = <FontAwesomeIcon icon={ faAngleDown } color="#ffffff" />
   return (
      <div className="grout-product-list">
         <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
         {
            groutSubCategories.map((gsc, index) => {
               return gsc!=='' && ( // REMOVE THIS CONDITIONAL ONCE ALL GROUT ITEMS HAVE SUBCATEGORIES APPLIED
                  <div className="panel panel-primary" key={ gsc }>
                     <div className="panel-heading" role="tab" id={ "heading-" + gsc }>
                        <a role="button" data-bs-toggle="collapse" data-parent="#accordion" href={ "#collapse-" + index } aria-expanded="true" aria-controls={ "collapse-" + index }>
                           <h4 className="panel-title">{ iconAngleDown } { gsc }</h4>
                        </a>
                     </div>
                     <div id={ "collapse-" + index } className={ index===0 ? "panel-collapse collapse show" : "panel-collapse collapse" } role="tabpanel" aria-labelledby={ "heading-" + gsc }>
                        <div className="panel-body">
                           {
                                   groutProducts.map((g, index) => {
                                  return g.subCategory === gsc && (
                                    <GroutProduct key={ g.groutName } productIndex={ index } { ...g } />
                                 )
                              })
                           }
                        </div>
                     </div>
                  </div>
               )
            })
         }
         {
            groutProducts.some(g => !g.subCategory) && (
               <div className="panel panel-primary list-items" key={ "no-subcategory" }>
                  <div className="panel-heading" role="tab" id={ "heading-no-subcategory" }>
                     <h4 className="panel-title">
                        <a role="button" data-bs-toggle="collapse" data-parent="#accordion" href={ "#collapse-no-subcategory" } aria-expanded="true" aria-controls={ "collapse-no-subcategory" }>
                           Uncategorized Adhesives
                        </a>
                     </h4>
                  </div>
                  <div id={ "collapse-no-subcategory" } className="panel-collapse collapse" role="tabpanel" aria-labelledby={ "heading-no-subcategory" }>
                     <div className="panel-body">
                     {
                        groutProducts.map((g, index) => {
                           return !g.subCategory && (
                              <GroutProduct key={ g.name } productIndex={ index } { ...g } />
                           )
                        })
                     }
                     </div>
                  </div>
               </div>
            )
         }
         </div>
      </div>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/grout/GroutProductList.js